/** @format */

const IconCategoryWeather = () => (
  <svg width='42' height='10' viewBox='0 0 42 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    {/* Mercury bulb (filled) */}
    <circle cx='5' cy='5' r='3' fill='currentColor' />
    {/* Mercury level (left half of tube) */}
    <rect x='5' y='4' width='17' height='2' fill='currentColor' />
    {/* Thermometer bulb outline */}
    <path
      d='M5 0C6.636 0 8.088.786 9 2h1v1H8.5l-.3-.4C7.469 1.627 6.308 1 5 1 2.791 1 1 2.791 1 5s1.791 4 4 4v1C2.239 10 0 7.761 0 5S2.239 0 5 0ZM10 8H9c-.912 1.214-2.364 2-4 2V9c1.308 0 2.469-.627 3.2-1.601l.3-.399H10v1Z'
      fill='currentColor'
    />
    {/* Tube top border */}
    <rect x='10' y='2' width='28' height='1' fill='currentColor' />
    {/* Tube bottom border */}
    <rect x='10' y='7' width='28' height='1' fill='currentColor' />
    {/* Tube right end cap */}
    <path
      d='M39 2c1.657 0 3 1.343 3 3s-1.343 3-3 3h-1V7h1c1.105 0 2-.895 2-2s-.895-2-2-2h-1V2h1Z'
      fill='currentColor'
    />
  </svg>
);

export default IconCategoryWeather;
